import { render, staticRenderFns } from "./MediaSearchVideos.vue?vue&type=template&id=195bf67b&scoped=true&lang=pug&"
import script from "./MediaSearchVideos.vue?vue&type=script&lang=js&"
export * from "./MediaSearchVideos.vue?vue&type=script&lang=js&"
import style0 from "./MediaSearchVideos.vue?vue&type=style&index=0&id=195bf67b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195bf67b",
  null
  
)

export default component.exports